import React from "react";

type Props = {
  className?: string;
  size?: number;
  color?: string;
};

const ExportIcon = ({ className = "", size = 16, color = "#1F2937" }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66675 6.66666L8.00008 9.99999L11.3334 6.66666"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 10V2" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ExportIcon;
